import { render, staticRenderFns } from "./settings.html?vue&type=template&id=40417bf1&scoped=true&"
import script from "./settings.js?vue&type=script&lang=js&"
export * from "./settings.js?vue&type=script&lang=js&"
import style0 from "./settings.css?vue&type=style&index=0&id=40417bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40417bf1",
  null
  
)

export default component.exports